import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { DocumentMaster } from "../model/DocumentMaster.model";
import { EnrollCourseMaster } from "../model/EnrollCourseMaster.model";
import { PredefinedMaster } from "../model/PredefinedMaster.model";
import { StudentMaster } from "../model/StudentMaster.model";
import { User } from "../model/User.model";
import { UserDocument } from "../model/UserDocument.model";
import { UserOtherDetails } from "../model/UserOtherDetails.model";
import { AuthService } from "../service/auth.service";
import { MainserviceService } from "../service/mainservice.service";
import { MessageService } from "primeng/api";
import { NgxSpinnerService } from "ngx-spinner";

declare var require: any;
const FileSaver = require("file-saver");
@Component({
  selector: "app-my-profile",
  templateUrl: "./my-profile.component.html",
  styleUrls: ["./my-profile.component.scss"],
})
export class MyProfileComponent implements OnInit {
  editPage: boolean = false;
  student: StudentMaster = new StudentMaster();
  studentMasterFilter: StudentMaster = new StudentMaster();
  userOtherDetails: UserOtherDetails = new UserOtherDetails();
  user: User = new User();
  documentMaster: DocumentMaster = new DocumentMaster();
  ongoingRecord: number = 0;
  completedRecord: number = 0;
  uploadthumnailImagePath: any[] = [];
  userDocument: UserDocument = new UserDocument();
  thumnailImagePath: any[] = [];
  value: Date;
  userTemp: User;
  locationList: PredefinedMaster[] = [];
  genderList: PredefinedMaster[] = [];
  predefinedMaster: PredefinedMaster = new PredefinedMaster();
  predefinedMasterTemp: PredefinedMaster = new PredefinedMaster();
  dateTemp: Date;
  dateTempYear: number;
  resumeDocumentPath: any[] = [];
  uploadDocumentResumePath: any[] = [];
  documentMasterResume: DocumentMaster = new DocumentMaster();
  errorBean: any = {};

  cities: any[];
  states: any[];

  selectedCity: any;

  enrollCourseMaster: EnrollCourseMaster = new EnrollCourseMaster();
  enrollCourseMasterTemp: EnrollCourseMaster = new EnrollCourseMaster();

  constructor(
    private authService: AuthService,
    private mainService: MainserviceService,
    private router: Router,
    public datepipe: DatePipe,
    private messageService: MessageService,
    public spinnerService: NgxSpinnerService
  ) {
    this.cities = [
      { name: "Mumbai", code: "NY" },
      { name: "Delhi", code: "RM" },
      { name: "Nagpur", code: "LDN" },
      { name: "Pune", code: "IST" },
    ];

    this.states = [
      { name: "Maharashtra", code: "NY" },
      { name: "Karnataka", code: "RM" },
      { name: "Goa", code: "LDN" },
    ];
  }

  ngOnInit() {
    this.spinnerService.show();
    this.student = this.authService.getUserSession();
    this.getStudentById();
    this.getEnrollCourseMasterListLength(this.student, "ONGOING");
    this.getEnrollCourseMasterListLength(this.student, "COMPLETED");
    this.getLocationList("LOCATION");
  }
  updatePage() {
    this.dateTemp = new Date();
    this.dateTempYear = this.dateTemp.getFullYear();

    this.editPage = true;
  }
  backPage() {
    this.editPage = false;
  }

  getStudentById() {
    this.studentMasterFilter.studentMasterId = this.student.studentMasterId;

    this.mainService.getStudentMasterById(this.studentMasterFilter).subscribe(
      (data) => {
        this.studentMasterFilter = data;
        this.user = this.studentMasterFilter.user;
        if (
          this.studentMasterFilter.user.dob == null ||
          this.studentMasterFilter.user.dob == undefined
        ) {
          let date: Date;
          this.studentMasterFilter.user.dob = date;
        } else {
          this.studentMasterFilter.user.dob = new Date(
            this.studentMasterFilter.user.dob
          );
        }

        this.authService.setUserSession(this.studentMasterFilter);

        this.getLocationList("GENDER");

        this.spinnerService.hide();
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            this.authService.setUserSession(this.studentMasterFilter);
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage("error", "Something went wrong", "");
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  getLocationList(type: string) {
    this.predefinedMaster.entityType = type;

    this.mainService.getPredefinedListByType(this.predefinedMaster).subscribe(
      (data) => {
        if (type == "LOCATION") {
          this.locationList = data;
        } else if (type == "GENDER") {
          this.genderList = data;

          this.genderList.forEach((gender) => {
            if (gender.name == this.studentMasterFilter.user.gender) {
              this.studentMasterFilter.user.genderPredefinedTemp = gender;
            }
          });
        }
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage("error", "Something went wrong", "");
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  addWork() {
    this.userOtherDetails = new UserOtherDetails();
    this.studentMasterFilter.user.workExperienceList.push(
      this.userOtherDetails
    );
  }

  deleteWork(userOtherDetails: UserOtherDetails) {
    this.studentMasterFilter.user.workExperienceList =
      this.studentMasterFilter.user.workExperienceList.filter(
        (data) => data !== userOtherDetails
      );
  }

  addQualification() {
    this.userOtherDetails = new UserOtherDetails();
    this.studentMasterFilter.user.educationQualificationList.push(
      this.userOtherDetails
    );
  }

  deleteQualification(userOtherDetails: UserOtherDetails) {
    this.studentMasterFilter.user.educationQualificationList =
      this.studentMasterFilter.user.educationQualificationList.filter(
        (data) => data !== userOtherDetails
      );
  }

  getEnrollCourseMasterListLength(studentMaster: StudentMaster, code: string) {
    this.enrollCourseMasterTemp.studentMaster = new StudentMaster();
    this.enrollCourseMasterTemp.studentMaster.studentMasterId =
      studentMaster.studentMasterId;
    this.enrollCourseMasterTemp.courseStatus = new PredefinedMaster();
    this.enrollCourseMasterTemp.courseStatus.code = code;

    this.mainService
      .getEnrollCourseMasterListLength(this.enrollCourseMasterTemp)
      .subscribe(
        (data) => {
          if (code == "ONGOING") {
            this.ongoingRecord = data;
          } else if (code == "COMPLETED") {
            this.completedRecord = data;
          }
        },
        (error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 200) {
              let jsonString = error.error.text;
              jsonString = jsonString.substr(
                0,
                jsonString.indexOf('{"timestamp"')
              );
              //   this.spinnerService.hide();
              return JSON.parse(jsonString);
            } else {
              this.authService.showMessage("error", "Something went wrong", "");
              //  this.spinnerService.hide();
            }
          }
        }
      );
  }

  updateStudent() {
    if (this.studentMasterFilter.user.gstNo !== null) {
      if (!this.validateGSTNumber(this.studentMasterFilter.user.gstNo)) {
        this.errorBean.gstNoMsg = "Please enter valid Gst No";
        this.errorBean.gstNo = true;
        return;
      }
    }
    if (this.studentMasterFilter.user.userImageList == null) {
      this.studentMasterFilter.user.userImageList = [];
    }

    this.studentMasterFilter.user.userImageList = this.user.userImageList;

    this.studentMasterFilter.user.resumeDocument = this.user.resumeDocument;

    if (this.studentMasterFilter.user.genderPredefinedTemp != null) {
      this.studentMasterFilter.user.gender =
        this.studentMasterFilter.user.genderPredefinedTemp.name;
    }

    this.studentMasterFilter.user.dobStr = this.datepipe.transform(
      this.studentMasterFilter.user.dob,
      "yyyy-MM-dd"
    );

    this.mainService.updateStudentDetail(this.studentMasterFilter).subscribe(
      (data) => {
        this.studentMasterFilter = data;
        this.messageService.add({
          severity: "success",
          summary: "Profile Updated",
          detail: "Successfully",
        });
        this.getStudentById();
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            this.messageService.add({
              severity: "success",
              summary: "Profile Updated",
              detail: "Successfully",
            });
            this.getStudentById();
            this.backPage();

            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            // return JSON.parse(jsonString);
          } else {
            this.authService.showMessage("error", "Something went wrong", "");
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  validateGSTNumber(gstNumber: string): boolean {
    const pattern =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
    return pattern.test(gstNumber);
  }

  uploadThumbnail(event: any, fileType: string) {
    for (let file of event.target.files) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        this.thumnailImagePath.push(reader.result);
      };

      this.uploadthumnailImagePath.push(file);
    }
    this.getDocumentPath(fileType);
  }
  getDocumentPath(fileType: string) {
    this.mainService.getDocumentPath(this.uploadthumnailImagePath).subscribe(
      (data) => {
        this.documentMaster = data;
        this.userDocument.documentMaster = this.documentMaster;

        if (this.user.userImageList == null) {
          this.user.userImageList = [];
          this.user.userImageList.push(this.userDocument);
        } else {
          this.user.userImageList[0] = this.userDocument;
        }

        this.uploadthumnailImagePath = [];
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;
        }
      }
    );
  }

  uploadDocumentResume(event: any, fileType: string) {
    for (let file of event.target.files) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        this.resumeDocumentPath.push(reader.result);
      };

      this.uploadDocumentResumePath.push(file);
    }
    this.getDocumentResume(fileType);
    this.uploadDocumentResumePath = [];
  }

  getDocumentResume(fileType: string) {
    this.documentMasterResume = new DocumentMaster();
    this.mainService.getDocumentPath(this.uploadDocumentResumePath).subscribe(
      (data) => {
        this.documentMasterResume = data;

        this.user.resumeDocument = this.documentMasterResume;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 200) {
          let jsonString = err.error.text;
        }
      }
    );
  }

  downloadFile(fileUrl: string) {
    if (fileUrl === null) {
      this.messageService.add({
        severity: "error",
        summary: "No Brochure",
        detail: "available",
      });
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);
  }

  downloadResume() {
    if (this.studentMasterFilter.user.resumeDocument.filePath != null) {
      this.downloadFile(this.studentMasterFilter.user.resumeDocument.filePath);
    } else {
      this.messageService.add({
        severity: "error",
        summary: "No Resume available",
        detail: "available",
      });
    }
  }
}
